export enum AccommodationType {
  Se = 'SE',
  Le = 'LE',
  Be = 'BE',
}
